/* =========================================================
   VRO Kits — landing banner pager, listing filter/sort, kit PDP "Save kit"
   Loaded by sections/kits-hero, kits-listing and kit-detail. Each of those
   emits its own <script src> tag, so this file can be included more than
   once on a page; the guard below makes the second include a no-op.
   ========================================================= */
(function () {
  if (window.__vroKitsInit) return;
  window.__vroKitsInit = true;

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------------------------------------------------------
       Landing: banner dots
       The track is a real horizontal scroller, so the dots only need to
       scroll it and mirror where it already is — swipe and trackpad keep
       working on their own, and the dots stay in step either way.
    --------------------------------------------------------- */
    var banner = document.querySelector('[data-kits-banner]');
    if (banner) {
      var track = banner.querySelector('[data-kits-banner-track]');
      var dots = Array.prototype.slice.call(banner.querySelectorAll('[data-kits-banner-dot]'));
      var cards = track ? Array.prototype.slice.call(track.children) : [];

      var markActive = function (index) {
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      };

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-kits-banner-dot'), 10);
          var card = cards[index];
          if (!card || !track) return;
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          markActive(index);
        });
      });

      if (track) {
        var scrollTimer;
        track.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            /* whichever card's left edge sits closest to the viewport's */
            var nearest = 0;
            var best = Infinity;
            cards.forEach(function (card, i) {
              var delta = Math.abs((card.offsetLeft - track.offsetLeft) - track.scrollLeft);
              if (delta < best) { best = delta; nearest = i; }
            });
            markActive(nearest);
          }, 80);
        }, { passive: true });
      }
    }

    /* ---------------------------------------------------------
       Listing: filter + sort
    --------------------------------------------------------- */
    var listing = document.querySelector('[data-kits-listing]');
    if (listing) {
      var grid = listing.querySelector('[data-kits-grid]');
      var cardsAll = grid ? Array.prototype.slice.call(grid.querySelectorAll('.kit-card')) : [];
      var noneMsg = listing.querySelector('[data-kits-none]');
      var countEl = listing.querySelector('[data-kits-count]');
      var sortLabelEl = listing.querySelector('[data-kits-sort-label]');
      var clearAllBtn = listing.querySelector('[data-kits-clear-all]');
      var activeDot = listing.querySelector('[data-kits-active-dot]');

      /* A card's stamped value list, e.g. data-kit-concern="Hairfall, Dry skin" */
      var valuesOf = function (card, key) {
        var raw = card.getAttribute('data-kit-' + key) || '';
        if (!raw) return [];
        return raw.split(',').map(function (v) { return v.trim(); }).filter(Boolean);
      };

      var checkedValues = function (key) {
        return Array.prototype.slice
          .call(listing.querySelectorAll('[data-kits-filter="' + key + '"]:checked'))
          .map(function (input) { return input.value; });
      };

      var matches = function (card) {
        var concerns = checkedValues('concern');
        if (concerns.length) {
          var cardConcerns = valuesOf(card, 'concern');
          if (!concerns.some(function (v) { return cardConcerns.indexOf(v) !== -1; })) return false;
        }
        var styles = checkedValues('style');
        if (styles.length) {
          var cardStyles = valuesOf(card, 'style');
          if (!styles.some(function (v) { return cardStyles.indexOf(v) !== -1; })) return false;
        }
        var bands = checkedValues('price');
        if (bands.length) {
          var price = parseInt(card.getAttribute('data-kit-price'), 10) || 0;
          var inBand = bands.some(function (band) {
            var parts = band.split(':');
            return price >= parseInt(parts[0], 10) && price < parseInt(parts[1], 10);
          });
          if (!inBand) return false;
        }
        return true;
      };

      var matchCount = function () {
        return cardsAll.filter(matches).length;
      };

      var sortCards = function (visible) {
        var mode = (listing.querySelector('[data-kits-sort]:checked') || {}).value || 'saved';
        var num = function (card, attr) { return parseInt(card.getAttribute(attr), 10) || 0; };
        var sorted = visible.slice();
        if (mode === 'price-asc') {
          sorted.sort(function (a, b) { return num(a, 'data-kit-price') - num(b, 'data-kit-price'); });
        } else if (mode === 'price-desc') {
          sorted.sort(function (a, b) { return num(b, 'data-kit-price') - num(a, 'data-kit-price'); });
        } else if (mode === 'name') {
          sorted.sort(function (a, b) {
            var an = (a.querySelector('.kit-card-name') || {}).textContent || '';
            var bn = (b.querySelector('.kit-card-name') || {}).textContent || '';
            return an.trim().localeCompare(bn.trim());
          });
        } else {
          sorted.sort(function (a, b) { return num(b, 'data-kit-save') - num(a, 'data-kit-save'); });
        }
        return sorted;
      };

      var apply = function () {
        var visible = cardsAll.filter(matches);
        cardsAll.forEach(function (card) { card.hidden = visible.indexOf(card) === -1; });
        /* Re-append in sort order. Hidden cards keep their place in the DOM
           after the visible ones, so nothing is lost when a filter clears. */
        sortCards(visible).forEach(function (card) { grid.appendChild(card); });
        cardsAll.forEach(function (card) { if (card.hidden) grid.appendChild(card); });

        if (noneMsg) noneMsg.hidden = visible.length !== 0 || cardsAll.length === 0;
        if (countEl) countEl.textContent = visible.length;

        var anyFilter = checkedValues('concern').length + checkedValues('style').length + checkedValues('price').length > 0;
        if (activeDot) activeDot.hidden = !anyFilter;
        if (clearAllBtn) {
          clearAllBtn.disabled = !anyFilter;
          clearAllBtn.classList.toggle('is-active', anyFilter);
        }

        /* Each group's pill shows as selected while that group is filtering. */
        ['concern', 'style', 'price'].forEach(function (key) {
          var pill = listing.querySelector('[data-kits-pop="' + key + '"]');
          if (pill) pill.classList.toggle('is-active', checkedValues(key).length > 0);
        });

        /* Every popover's button counts what applying would leave. */
        var n = visible.length;
        listing.querySelectorAll('[data-kits-apply-count]').forEach(function (el) { el.textContent = n; });
      };

      var closePopovers = function (except) {
        listing.querySelectorAll('[data-kits-panel]').forEach(function (panel) {
          if (panel === except) return;
          panel.hidden = true;
          var pill = listing.querySelector('[data-kits-pop="' + panel.getAttribute('data-kits-panel') + '"]');
          if (pill) pill.setAttribute('aria-expanded', 'false');
        });
      };

      listing.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-kits-pop]');
        if (pill) {
          var panel = listing.querySelector('[data-kits-panel="' + pill.getAttribute('data-kits-pop') + '"]');
          var willOpen = panel && panel.hidden;
          closePopovers(willOpen ? panel : null);
          if (panel) {
            panel.hidden = !willOpen;
            pill.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          }
          return;
        }

        var applyBtn = e.target.closest('[data-kits-apply]');
        if (applyBtn) { closePopovers(null); return; }

        var clearBtn = e.target.closest('[data-kits-clear]');
        if (clearBtn) {
          var key = clearBtn.getAttribute('data-kits-clear');
          listing.querySelectorAll('[data-kits-filter="' + key + '"]').forEach(function (input) { input.checked = false; });
          apply();
          return;
        }

        if (e.target.closest('[data-kits-clear-all]')) {
          listing.querySelectorAll('[data-kits-filter]').forEach(function (input) { input.checked = false; });
          apply();
          closePopovers(null);
          return;
        }

        /* A click inside a popover must not close it. */
        if (e.target.closest('[data-kits-panel]')) return;
        closePopovers(null);
      });

      document.addEventListener('click', function (e) {
        if (!listing.contains(e.target)) closePopovers(null);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePopovers(null);
      });

      listing.addEventListener('change', function (e) {
        if (e.target.matches('[data-kits-filter]')) { apply(); return; }
        if (e.target.matches('[data-kits-sort]')) {
          if (sortLabelEl) {
            var label = e.target.closest('.kits-popover-option');
            var text = label ? label.querySelector('.kits-popover-label') : null;
            if (text) sortLabelEl.textContent = text.textContent.trim();
          }
          apply();
          closePopovers(null);
        }
      });

      apply();
    }

    /* ---------------------------------------------------------
       Kit PDP: "Save kit" — puts every product in the kit on the existing
       per-product wishlist (assets/wishlist.js owns the storage), rather
       than inventing a second, kit-shaped list the wishlist panel could
       not render.
    --------------------------------------------------------- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kit-save-all]');
      if (!btn) return;
      e.preventDefault();

      var handles = (btn.getAttribute('data-kit-save-all') || '').split(',').filter(Boolean);
      if (!handles.length || !window.VroWishlist) return;

      /* All-or-nothing, like the add-to-cart: if every item is already
         saved the press removes them, otherwise it saves whatever is
         missing — so the button never half-toggles a kit. */
      var allSaved = handles.every(function (handle) { return window.VroWishlist.has(handle); });
      handles.forEach(function (handle) {
        if (window.VroWishlist.has(handle) === allSaved) window.VroWishlist.toggle(handle);
      });
      window.VroWishlist.sync();

      if (window.showToast) {
        window.showToast(allSaved ? 'Kit removed from wishlist' : 'Kit saved to wishlist', 'wishlist');
      }
      btn.classList.toggle('is-saved', !allSaved);
    });

  });
})();
